import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createWeb3ReactRoot, Web3ReactProvider } from "@web3-react/core"
import { Provider } from 'react-redux'
import App from './App';
import reportWebVitals from './reportWebVitals';
import getLibrary from "./utils/getLibrary";
import { Web3AuthContextProvider } from './contexts/web3Auth';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import store from './store/store';

import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const Web3ProviderNetwork = createWeb3ReactRoot("Network");

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#5a5a5a',
    },
    secondary: {
      main: '#999999',
    },
    info: {
      main: '#FF5733',
    },
    error: {
      main: '#FF5733',
    }
  },
  typography: {
    fontFamily: ["Montserrat"].join(","),
    h5: {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: '#5a5a5a'
    },
    h6: {
      fontSize: "1.2rem",
      fontWeight: 500,
      color: '#5a5a5a',
      letterSpacing: '1'
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 400,
      color: '#5a5a5a'
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 200,
      color: '#999999'
    },
    body2: {
      fontSize: "16px",
      fontWeight: 400,
      color: '#999999'
    }
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h2',
          h2: 'h2',
          h3: 'h2',
          h4: 'h2',
          h5: 'h2',
          h6: 'h2',
          subtitle1: 'h2',
          subtitle2: 'h2',
          body1: 'span',
          body2: 'span',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          color: '#999999',
          fontWeight: 500,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--divider)'
          }
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          fontSize: "18px"
        }
      }
    }
    // MuiDateCalendar: {
    //   styleOverrides: {
    //     root: {
    //       color: '#1565c0',
    //       borderRadius: '2px',
    //       borderWidth: '1px',
    //       borderColor: '#2196f3',
    //       border: '1px solid',
    //       backgroundColor: '#90caf9',
    //     }
    //   }
    // }
  },
});


root.render(
  <React.StrictMode>
    <Web3ReactProvider getLibrary={getLibrary}>
      <Web3ProviderNetwork getLibrary={getLibrary}>
        <Provider store={store}>
          <BrowserRouter>
            <Web3AuthContextProvider>
              <ThemeProvider theme={theme}>
                <App />
              </ThemeProvider>
            </Web3AuthContextProvider>
          </BrowserRouter>
        </Provider>
      </Web3ProviderNetwork>
    </Web3ReactProvider>
  </React.StrictMode>
);

reportWebVitals();
